import { Base64Downloader } from 'utils/Base64Downloader';
import { dictionary } from '../dictionary/dictionary';
import { delete_receiption } from 'Routes/Protected/FreezeContracts/Functions/delete_receiption';

export const actions = (
  receiption,
  setReceptions,
  details
) => {
  const { previewMsg, deleteMsg } = dictionary();

  const data = [
    {
      name: previewMsg,
      fn: () => {
        Base64Downloader(
          `${receiption?.base64Extention}${receiption?.imageArrayContent?.image}`
        );
      },
      disabled: false,
      icon: '',
      fwidth: 'true',
      variant: 'contained',
    },
    {
      name: deleteMsg,
      fn: () => {
        delete_receiption(
          receiption?.Id,
          setReceptions,
          details?.IdTestimontial
        );
      },
      disabled: false,
      icon: '',
      fwidth: 'true',
      variant: 'contained',
    },
  ];
  return data;
};
